import { render, staticRenderFns } from "./CornerRibbon.vue?vue&type=template&id=3bae7757&scoped=true"
var script = {}
import style0 from "./CornerRibbon.vue?vue&type=style&index=0&id=3bae7757&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae7757",
  null
  
)

export default component.exports